
<template>
  <div class="question">
    <a-spin class="load" v-show="loading" />
    <div class="top">
<!--      <span class="icon"-->
<!--            @click="goHistory"><img class="goHistory"-->
<!--             src="../../assets/image/08.png"-->
<!--             alt=""></span>-->
<!--      <span class="iconText"-->
<!--            v-if="show==2">待解决问题-问题处理</span>-->
<!--      <span class="iconText"-->
<!--            v-if="hide==1">已解决问题-问题归类</span>-->
      <a-breadcrumb class="breadcrumb">
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/homePage'">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px">
          <router-link :to="'/accompanyStudy/questionSolve'">待解决问题</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px" v-if="show==2">
          问题处理
        </a-breadcrumb-item>
        <a-breadcrumb-item style="font-size: 16px" v-if="show==1">
          问题归类
        </a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="content">
      <div class="contMes">
        <div class="mesList">
          <a-checkbox-group style="width:100%;" v-model="checkedList" :options="plainOptions.id" @change="onChange">
            <a-list item-layout="vertical"
                    size="large"
                    :data-source="listData">
              <a-list-item slot="renderItem" key="item.title" slot-scope="item">
                <a-list-item-meta :description="item.description">
                  <div slot="title">
                    <div class="prepare">
                      <a-checkbox :value="item" class="checkBox"></a-checkbox>
                      <div class="bookName">{{item.lessonTitle}}</div>
                      <p class="bookTitle">{{item.textContent}}</p>
                      <a-row>
                        <a-col :span="1">
                          <img class="photoImg" v-if="item.userPhoto&&item.userPhoto!=null" :src="$userINfoBasePath+'/'+item.userPhoto" alt="" />
                          <img class="photoImg" v-else src="../../../src/assets/imgs/student.png" alt="" />
                        </a-col>
                        <a-col :span="23">
                          <span class="userName">{{item.userName}}</span><span class="userSchool">{{item.userClassInfo}}</span>
                          <p class="questionText">{{item.content}}</p>
                          <p class="date">{{format.formatDayTime(item.createDate)}}</p>
                          <div v-for="(t,index) in item.replyList" :key="'child'+index">
                            <img class="photoImg" v-if="t.userPhoto&&t.userPhoto!=null" :src="$userINfoBasePath+'/'+t.userPhoto" alt="" />
                            <span class="userName">{{t.userName}}</span>
                            <span class="fuhao">@</span><span class="userSchool">{{t.recuserName}}</span>
                            <p class="questionText">{{t.replyContent}}</p>
                            <p class="date">{{format.formatDayTime(t.createDate)}}</p>
                          </div>
                          <div class="forAsk" @click="goLookAsk(item.id)"> 查看全部回答 </div>
                        </a-col>
                      </a-row>
                    </div>
                    <div class="askHelp"> </div>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
            <div class="askPage">
              <a-config-provider>
                <a-pagination :default-current="1"
                              :page-size="pageSize"
                              @change="handleListChange"
                              :total='total' />
              </a-config-provider>
            </div>
          </a-checkbox-group>
          <div class="askHelp">
            <a-checkbox class="allSelect"
                        :indeterminate="indeterminate"
                        :checked="checkAll"
                        @change="onCheckAllChange">全选</a-checkbox>
            <span style="color: #9d9292;font-size:20px;margin-left:20px;"
                  disabled='false'>已选择{{this.checkedList.length}}个</span>
            <a-button class="help"
                      :disabled="disabledBtn"
                      v-if="show==2?false:true"
                      @click="askForProfession()">问题归类</a-button>
            <a-button class="ask"
                      :disabled="disabledBtn"
                      v-if="hide==1? false:true"
                      @click="unifiedAnswer()">统一回答</a-button>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="lookMore"
             width="1100px"
             title="查看全部回答"
             footer=""
             destroyOnClose>
      <div class="mesMore">
        <div slot="title">
          <div class="prepare">
            <div class="bookName">{{allAnswer.lessonTitle}}</div>
            <p class="bookTitle">{{allAnswer.textContent}}</p>
            <a-row>
              <a-col :span="1">
                <img class="photoImg"
                     v-if="allAnswer.userPhoto"
                     :src="$userINfoBasePath+'/'+allAnswer.userPhoto"
                     alt="" />
              </a-col>
              <a-col :span="23">
                <span class="userName">{{allAnswer.userName}}</span><span class="userSchool">{{allAnswer.userClassInfo}}</span>
                <p class="questionText">{{allAnswer.askContent}}</p>
                <p class="date">{{format.formatDayTime(allAnswer.createDate)}}</p>
                <div v-for="(t,index) in allAnswer.replyList"
                     :key="'child'+index">
                  <img class="photoImg"
                       v-if="t.userPhoto&&t.userPhoto!=null"
                       :src="$userINfoBasePath+'/'+t.userPhoto"
                       alt="" />
                  <img class="photoImg"
                       v-else
                       src="../../../src/assets/imgs/teacher.png"
                       alt="" />
                  <span class="userName">{{t.userName}}</span>
                  <span class="fuhao">@</span><span class="userSchool">{{t.recuserName}}</span>
                  <p class="questionText">{{t.replyContent}}</p>
                  <p class="date">{{format.formatDayTime(t.createDate)}}</p>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="askHelp">
        <a-button class="help"
                  @click="askFor(allAnswer)">求助专家</a-button>
        <a-button class="ask"
                  @click="answer(allAnswer)">回答</a-button>
      </div>
    </a-modal>
    <a-modal v-model="unifiedAnswerModel"
             class="askModel"
             width="1100px"
             title=" "
             footer="">
      <div class="asktitle"
           v-if="askAll">统一回答</div>
      <div class="asktitle"
           v-if="askTitle">问题归类</div>
      <div class="unifiedAnswer"
           v-for="(item,index) in unifiedAnswerList"
           :key="index">
        <div slot="title">
          <div class="prepare">
            <div class="bookName">{{item.lessonTitle}}</div>
            <p class="bookTitle">{{item.textContent}}</p>
            <a-row>
              <a-col :span="1">
                <img class="photoImg"
                     v-if="item.userPhoto"
                     :src="$userINfoBasePath+'/'+item.userPhoto"
                     alt="" />
              </a-col>
              <a-col :span="23">
                <span class="userName">{{item.userName}}</span><span class="userSchool">{{item.userClassInfo}}</span>
                <p class="questionText">{{item.askContent}}</p>
                <p class="date">{{format.formatDayTime(item.createDate)}}</p>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="answerBgc"
           style="margin-top:10px;">
        <a-textarea v-model="replyContent"
                    :auto-size="{ minRows: 6, maxRows: 10 }" />
      </div>
      <div class="askHelp"
           style="margin-top:10px;">
        <a-button v-if="askAll"
                  class="ask"
                  @click="teacherBatchReplyAsk">确定</a-button>
        <a-button v-if="askTitle"
                  class="ask"
                  @click="teacherBatchReplyTitle">确定</a-button>
      </div>
    </a-modal>
    <!--回答弹窗-->
    <!-- <a-modal v-model="answerModal"
             width="1100px"
             title=""
             footer="">
      <div class="answerMes">
        <div><span class="answerText">回答</span><span class="answerName">王琦啊</span></div>
        <div class="answerTitle">如何理解某某某某某的啊？</div>
        <div class="answerBgc">
          <a-textarea v-model="value"
                      :auto-size="{ minRows: 6, maxRows: 10 }" />
        </div>
      </div>
      <div class="askHelp">
        <a-button class="ask">确定</a-button>
      </div>
    </a-modal> -->
    <a-modal v-model="answerModal"
             style="z-index:99999;"
             width="1100px"
             title=""
             footer="">
      <div class="answerMes">
        <div><span class="answerText">回答</span><span class="answerName">{{askMess.userName}}</span></div>
        <div class="answerTitle">{{askMess.askContent}}</div>
        <div class="answerBgc">
          <a-textarea v-model="value"
                      :auto-size="{ minRows: 6, maxRows: 10 }" />
        </div>
      </div>
      <div class="askHelp">
        <a-button class="ask"
                  @click="teacherReplay(askMess)">确定</a-button>
      </div>
    </a-modal>
    <!--求助专家-->
    <a-modal v-model="zhuanjiaModal"
             width="576px"
             title=""
             footer="">
      <div class="zjcontent">
        <div class="title">求助专家</div>
        <div class="proplem">是否确定求助专家解答 <span class="name">{{userName}}</span> 的问题</div>
        <div class="zjFooter">
          <a-button class="cancle"
                    @click="zhuanjiaModal=false">取消</a-button>
          <a-button class="sure"
                    @click="askSure">确认</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import format from '../../utils/format.js'

export default {
  name: 'QuestionToSolve',
  data () {
    return {
      format,
      loading: true,
      checkedOr: false,
      checked: false,
      disabled: false,
      disabledBtn: false,
      zhuanjiaModal: false,
      checkMess: [],
      allAnswer: '', //查看更多
      resBasePath: this.$resBasePath,
      value: '',
      classId: '',
      askAll: true,
      askTitle: false,
      lookMore: false,//查看更多回答
      answerModal: false, //回答
      unifiedAnswerModel: false, //统一回答模型框
      titleMess: '',
      total: 0,
      pageSize: 5,
      pageNum: 1,
      listData: [],//列表数据
      checkedList: [],//选择列表
      indeterminate: true,//动画
      checkAll: false,//全选
      plainOptions: [],
      unifiedAnswerList: [], //合并回答
      replyContent: '',
      askMess: '',
      style: '',
      hide: '',
      show: ''
    }
  },
  computed: {

  },
  methods: {
    //每个复选框的绑定事件
    onChange (checkedList) {
      // console.log(checkedList)
      this.answerList = checkedList
      this.indeterminate = !!checkedList.length && checkedList.length < this.plainOptions.length
      this.checkAll = checkedList.length === this.plainOptions.length
    },
    //全选框的绑定事件
    onCheckAllChange (e) {
      Object.assign(this, {
        checkedList: e.target.checked ? this.plainOptions : [],
        indeterminate: false,
        checkAll: e.target.checked,
      })
      //console.log(this.checkedList)
    },
    handleListChange (current, pageSize) {
      this.checkAll = false
      this.pageNum = current
      this.pageSize = pageSize
      this.getQuestionList()
    },
    goHistory () {
      this.$router.go(-1)
    },
    answer (ans) {
      this.answerModal = true
      this.askMess = ans
    },
    unifiedAnswer () {//统一回答弹窗
      this.askAll = true
      this.askTitle = false
      this.unifiedAnswerList = this.checkedList
      if (this.unifiedAnswerList.length == 0) {
        this.unifiedAnswerModel = false
        this.$message.warning('请至少选择一项')
      } else {
        this.unifiedAnswerModel = true
      }
    },
    teacherBatchReplyAsk () {//统一回答确认
      this.titleMess = '统一回答'
      let recuserIds = [], askIds = [], bookIds = [], styleIds = [], replyContent = ''
      this.checkedList.forEach(item => {
        recuserIds.push(item.userId)
        askIds.push(item.id)
        bookIds.push(item.bookId)
        styleIds.push(item.styleId)
      })
      const param = {
        userId: this.$getUserInfo().id,
        recuserIds: recuserIds.toString(),
        rootIds: askIds.toString(),
        bookIds: bookIds.toString(),
        styleIds: styleIds.toString(),
        replyContent: this.replyContent
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/saveTeacherBatchReply',
        body: param
      }).done(
        res => {
          if (res && res.success && res.resultCode === 0) {
            // this.$message.success(res.success)
            this.unifiedAnswerModel = false
          }
          this.getQuestionList()
          this.replyContent = ''
        }
      )
    },
    teacherReplay (askMess) { //ebook/comment/teacherReplyAsk
      //console.log(askMess)
      const bookId = localStorage.getItem('syzg-bookId')
      const param = {
        userId: this.$getUserInfo().id,//用户id
        bookId: bookId,//书id
        styleId: askMess.styleId,//课id
        recuserId: askMess.userId,//被回复人id
        replyContent: this.value,//回复内容
        rootId: askMess.id,//问题id
        parentId: askMess.id//上级id
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/saveTeacherReply',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('回复成功')
          this.answerModal = false
          this.lookMore = false
          this.getQuestionList()
          this.value = ''
        }
      })
    },
    teacherBatchReplyTitle () {
      this.titleMess = '问题归类'
      let askIds = []
      this.checkedList.forEach(item => {
        askIds.push(item.id)
      })
      const param = {
        askIds: askIds.join(';').toString(),
        userId: this.$getUserInfo().id,
        title: this.replyContent
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/saveAskToClassification',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.unifiedAnswerModel = false
          this.replyContent = ''
        }
      })
    },
    goLookAsk (item) {
      this.lookMore = true
      // this.allAnswer = item
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getAskReplyPageByAskId',
        body: { id: item }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.allAnswer = res.resultData
        }
      })
    },
    askFor (item) {   //专家回复
      this.zhuanjiaModal = true
      this.userName = item.userName
      this.askParam = { //求助专家参数
        id: item.id, // 问题ID
        userId: this.$getUserInfo().id, //用户ID
        styleId: item.styleId
      }
    },
    askSure () { //求助专家
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/pushExpert',
        body: this.askParam
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.$message.success('已求助')
          this.zhuanjiaModal = false
        }
      })
    },
    askForProfession () {//问题归类
      this.unifiedAnswerList = this.checkedList
      this.askAll = false
      this.askTitle = true
      if (this.unifiedAnswerList.length == 0) {
        this.unifiedAnswerModel = false
        this.$message.warning('请至少选择一项')
      } else {
        this.unifiedAnswerModel = true
      }
    },
    getQuestionList () { // 待解决问题
      const param = {
        userId: this.$getUserInfo().id,
        classId: this.classId,
        styleId: this.style,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$fetch({
        url: this.$baseUrl + 'ebook/teacher/ask/getTeacherSolved',
        body: param
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        if (res && res.success && res.resultCode === 0) {
          this.listData = res.resultData.list
          this.total = res.resultData.total
          this.plainOptions = res.resultData.list
          if (this.total < 1) {
            this.disabledBtn = true
          }
        }
      })
    },
    userName () { }
  },
  mounted () {
    setTimeout(() => {
      this.getQuestionList()
    }, 1000)

    this.style = this.$route.params.id
    this.hide = this.$route.params.hide
    this.show = this.$route.params.show
  }
}
</script>
<style lang="less" scoped>
ul,
li,
p {
  margin: 0;
  padding: 0;
  list-style: none;
}
.question {
  position: relative;
  min-width: 1024px;
  max-width: 1680px;
  margin: 0 auto;

  .load {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(50%, 50%);
  }
  .top {
  //  height: 110px;
    //background-color: #fff;
    position: relative;
    padding: 0 30px;

    .breadcrumb{
      margin: 20px auto ;
      //width: 1200px;
    }
    .goHistory {
      width: 16px;
      height: 32px;
      cursor: pointer;
    }
    .icon {
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 50px;
    }
    .iconText {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 100px;
      color: #9d9292;
      font-size: 24px;
    }
  }
  .content {
    width: 100%;
    background: #f6f6f6;
    //padding-top: 30px;
    .contMes {
      //width: 1240px;
      background: #fff;
      margin: 0 auto;
      padding: 20px 50px;
      border-radius: 8px;

      .questionSolve {
        text-align: right;
        width: 120px;
        height: 32px;
        background-image: linear-gradient(122deg, #ff8d46 0%, #fa5542 100%);
        box-shadow: 0px 2px 8px 0px #dbcebc;
        border-radius: 16px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 32px;
        letter-spacing: 0px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
        margin-left: auto;
      }
    }
    .mesList {
      //width: 1140px;
      margin: 0 auto;
      background: #f6f6f6;
      margin-top: 20px;
      margin-bottom: 100px;
    }
  }
}
.prepare {
  padding: 20px;
  position: relative;
  .checkBox {
    position: absolute;
    left: 20px;
    bottom: 20px;
  }
  .bookName {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #9d9292;
  }
  .bookTitle {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 26px;
    letter-spacing: 0px;
    color: #000000;
    margin: 10px 0px;
  }
  .photoImg {
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .userName {
    font-size: 18px;
    color: #000;
    line-height: 26px;
  }
  .fuhao {
    font-size: 18px;
    color: #9d9292;
    margin-left: 0px;
    line-height: 26px;
  }
  .userSchool {
    font-size: 18px;
    color: #9d9292;
    margin-left: 10px;
    line-height: 26px;
  }
  .questionText {
    font-size: 20px;
    line-height: 30px;
    color: #040506;
  }
  .date {
    color: #9d9292;
    font-size: 14px;
  }
  .forAsk {
    text-align: right;
    height: 30px;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 0px;
    color: @primary-color;
    cursor: pointer;
  }
}
.ulList {
  margin-top: 10px;
  .listMes {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #9d9292;
    height: 30px;
    line-height: 30px;
  }
}
.askPage {
  height: 60px;
  width: 100%;
  background: #fff;
  text-align: center;
  /deep/.ant-pagination {
    padding-top: 15px;
  }
}
.askHelp {
  height: 10px;
  width: 100%;
  background: #fff;
  padding: 20px;
  .ask {
    width: 120px;
    height: 32px;
    background-color: @primary-color;
    border-radius: 4px;
    color: #ffffff;
    font-size: 16px;
    float: right;
  }
  .help {
    width: 120px;
    height: 32px;
    background-color: #a3af90;
    border-radius: 4px;
    color: #ffffff;
    font-size: 16px;
    float: right;
    margin-left: 20px;
  }
}
.mesMore {
  min-height: 160px;
  padding: 20px;
  background: #f6f6f6;
  overflow-y: auto;
}
.unifiedAnswer {
  padding: 20px;
  background: #f6f6f6;
  height: 100%;
}
.footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}
.answerMes {
  .answerText {
    font-size: 16px;
    color: #9d9292;
  }
  .answerName {
    color: @primary-color;
    font-size: 18px;
    margin-left: 20px;
  }
  .answerTitle {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 22px;
    letter-spacing: 0px;
    color: #000000;
    margin-top: 10px;
  }
  .answerBgc {
    margin-top: 10px;
    background-color: #f6f6f6;
  }
  /deep/.ant-input {
    background-color: #f6f6f6;
  }
}
.zjcontent {
  padding: 20px;
  .title {
    height: 50px;
    font-family: PingFangSC-Semibold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 50px;
    letter-spacing: 0px;
    color: #db5647;
    text-align: center;
  }
  .proplem {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 46px;
    letter-spacing: 0px;
    color: #040506;
    text-align: center;
    .name {
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: @primary-color;
    }
  }
  .zjFooter {
    text-align: center;
    margin-top: 10px;
    .cancle {
      width: 160px;
      height: 30px;
      background: #f6f6f6;
      color: #9d9292;
      font-size: 18px;
    }
    .sure {
      width: 160px;
      height: 30px;
      background: #f6f6f6;
      background-color: @primary-color;
      font-size: 18px;
      color: #fff;
      margin-left: 30px;
    }
  }
}
.askModel {
  /deep/.ant-modal-body {
    padding-top: 0px;
  }
}
.asktitle {
  height: 50px;
  font-family: PingFangSC-Semibold;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 50px;
  letter-spacing: 0px;
  color: #000000;
}
.allSelect {
  font-family: PingFangSC-Regular;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: @primary-color;
  margin-top: 16px;
}
/deep/.ant-modal-header {
  border-bottom: none;
}
/deep/.ant-modal-title {
  font-size: 24px;
  color: #000000;
}
/deep/.ant-list-pagination {
  text-align: center;
  background: #fff;
  margin-top: 0px;
}
/deep/.ant-list-vertical .ant-list-item-meta {
  margin-bottom: 0px;
}
/deep/.ant-list-split .ant-list-item {
  border-bottom: none;
}
/deep/.ant-list-something-after-last-item
  .ant-spin-container
  > .ant-list-items
  > .ant-list-item:last-child {
  border-bottom: none;
}
/deep/.ant-list-lg .ant-list-item {
  padding: 0px;
}
/deep/.ant-list-vertical .ant-list-item-meta-title {
  margin-bottom: 0px;
}
</style>
